// tslint:disable: no-var-requires
require('es6-promise').polyfill();
require('url-polyfill');
require('whatwg-fetch');
require('es6-symbol/implement');
require('mdn-polyfills/Object.assign');
require('mdn-polyfills/Object.create');
require('mdn-polyfills/Object.entries');
require('mdn-polyfills/Object.keys');
require('mdn-polyfills/Object.values');
require('mdn-polyfills/Array.from');
require('mdn-polyfills/Array.of');
require('mdn-polyfills/Array.prototype.fill');
require('mdn-polyfills/Array.prototype.filter');
require('mdn-polyfills/Array.prototype.find');
require('mdn-polyfills/Array.prototype.findIndex');
require('mdn-polyfills/Array.prototype.forEach');
require('mdn-polyfills/Array.prototype.includes');
require('mdn-polyfills/Array.prototype.some');
require('mdn-polyfills/Array.prototype.reduce');
require('mdn-polyfills/String.prototype.includes');
require('mdn-polyfills/String.prototype.repeat');
require('mdn-polyfills/String.prototype.startsWith');
require('mdn-polyfills/String.prototype.endsWith');
require('mdn-polyfills/String.prototype.padStart');
require('mdn-polyfills/String.prototype.padEnd');
require('mdn-polyfills/String.prototype.trim');
require('mdn-polyfills/Function.prototype.bind');
require('mdn-polyfills/Node.prototype.addEventListener');
require('mdn-polyfills/Node.prototype.append');
require('mdn-polyfills/Node.prototype.prepend');
require('mdn-polyfills/Node.prototype.before');
require('mdn-polyfills/Node.prototype.after');
require('mdn-polyfills/Node.prototype.remove');
require('mdn-polyfills/Node.prototype.replaceWith');
require('mdn-polyfills/Node.prototype.children');
require('mdn-polyfills/Node.prototype.firstElementChild');
require('mdn-polyfills/NodeList.prototype.forEach');
require('mdn-polyfills/Element.prototype.closest');
require('mdn-polyfills/Element.prototype.toggleAttribute');
require('mdn-polyfills/Element.prototype.matches');
require('mdn-polyfills/Element.prototype.classList');
require('mdn-polyfills/MouseEvent');
require('mdn-polyfills/CustomEvent');
require('mdn-polyfills/Number.isInteger');
require('mdn-polyfills/Number.isNaN');
// tslint:enable: no-var-requires
